import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Sidemenu from '../../components/sidemenu';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Dropdown from '../../components/elements/dropdown01';
import RadioButton from '../../components/elements/radioButton02';
import InputSuggestion from '../../components/elements/inputSuggestion01';
import Loader from '../../components/loader';
import Editor from './editor';
import * as Styled from './styled';
import {
  getRequest,
  addRequest,
  addClear,
  ownerRequest,
  testRequest,
  locationRequest,
  skillRequest,
  locationClear,
  skillClear,
} from './actions';

class AddContest extends Component {
  constructor (props) {
    super(props)
    this.state = {
      pageMode: '',
      locationTypeList: [
        { selected: false, title: 'Onsite' },
        { selected: false, title: 'Remote' },
        { selected: false, title: 'Hybrid' },
      ],
      currencyList: [
        { id: 'INR', title: 'INR' }
      ],
      jobTypeList: [
        { selected: false, title: 'Contract' },
        { selected: false, title: 'Internship' },
        { selected: false, title: 'FullTime' },
        { selected: false, title: 'Part time' },
        { selected: false, title: 'Freelance' },
      ]
    }
  }

  UNSAFE_componentWillMount() {
    let pageMode = 'add';

    if (window && window.location && window.location.pathname) {
      const pathArr = window.location.pathname.split('/');
      if (typeof pathArr[3] !== 'undefined' && pathArr[3] !== '') {
        this.props.getRequest(pathArr[3]);
        pageMode = pathArr[2];
      }
    }
    this.resetInput();
    this.props.ownerRequest();
    this.setState({ pageMode });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.addContest) {
      if (nextProps.addContest.addContest
        && nextProps.addContest.addContest.code === 200) {
        window.location = '/contest';
      }

      if (this.state.pageMode === 'edit'
      && this.state.contest
      && typeof this.state.contest.contest_id === 'undefined'
      && nextProps.addContest.getContest
      && nextProps.addContest.getContest.data
      && nextProps.addContest.getContest.data.contestData
      && nextProps.addContest.getContest.data.contestData[0]) {
        const con = nextProps.addContest.getContest.data.contestData[0];
        const contest = this.state.contest;
        if(con.contest_start_date){
          let currentTimeUTC = moment(con.contest_start_date).utc();
          let ISTTime = moment(currentTimeUTC).utcOffset("+05:30").format();
          con.contest_start_date = ISTTime.substr(0,16)
        }
        if(con.contest_end_date){
          let currentTimeUTC = moment(con.contest_end_date).utc();
          let ISTTime = moment(currentTimeUTC).utcOffset("+05:30").format();
          con.contest_end_date = ISTTime.substr(0,16)
        }
        contest.contest_id = con.id;
        contest.company_id = con.company_id || '';
        contest.job_title = con.job_title || '';
        contest.job_location_type = con.job_location_type || '';
        contest.job_location_list = con.job_location_list || [];
        contest.min_experience = con.min_experience ? con.min_experience.toString() : '';
        contest.max_experience = con.max_experience ? con.max_experience.toString() : '';
        contest.ctc_currency = 'INR';
        contest.min_ctc = con.min_ctc ? con.min_ctc.toString() : '';
        contest.max_ctc = con.max_ctc ? con.max_ctc.toString() : '';
        contest.openings = con.openings ? con.openings.toString() : '';
        contest.job_start_date = con.job_start_date ? con.job_start_date.split('T')[0] : '';
        contest.skills_list = con.skills_list || [];
        contest.job_type = con.job_type || '';
        contest.job_description = con.job_description || '';
        contest.contest_start_date = con.contest_start_date ?  con.contest_start_date  : '';
        contest.contest_end_date = con.contest_end_date ? con.contest_end_date: '';
        contest.test_id = con.test_id || '';

        const locationTypeList = this.state.locationTypeList;
        for (let x = 0; x < locationTypeList.length; x++) {
          if (locationTypeList[x].title.toUpperCase() === contest.job_location_type) {
            locationTypeList[x].selected = true;
            break;
          }
        }

        const jobTypeList = this.state.jobTypeList;
        for (let x = 0; x < jobTypeList.length; x++) {
          if (jobTypeList[x].title.toUpperCase() === contest.job_type) {
            jobTypeList[x].selected = true;
            break;
          }
        }

        if (con.company_id) {
          this.props.testRequest(con.company_id);
        }

        this.setState({ contest, locationTypeList, jobTypeList });
      }
    }
  }

  componentWillUnmount() {
    this.props.addClear();
    this.resetInput();
  }

  resetInput = () => {
    this.setState({
      contest: {
        company_id: '',
        job_title: '',
        job_location_type: '',
        job_location_list: [],
        min_experience: '',
        max_experience: '',
        ctc_currency: 'INR',
        min_ctc: '',
        max_ctc: '',
        openings: '',
        job_start_date: '',
        skills_list: [],
        job_type: '',
        job_description: '',
        contest_start_date: '',
        contest_end_date: '',
        test_id: '',
      },
      error: {
        company_id: '',
        job_title: '',
        job_location_type: '',
        job_location_list: '',
        experience: '',
        ctc: '',
        openings: '',
        job_start_date: '',
        skills_list: '',
        job_type: '',
        job_description: '',
        contest_start_date: '',
        contest_end_date: '',
        test_id: '',
      }
    });
  }

  cancelContest = () => {
    this.resetInput()
  }

  inputChange = (e) => {
    const { id, value } = e.target;
    const contest = this.state.contest;
    const error = this.state.error;

    if (id === 'min_experience' || id === 'max_experience' || id === 'openings') {
      const isnum = /^\d+$/.test(value);
      if (isnum === true || value === '') {
        contest[id] = value && value !== '' ? parseInt(value, 10).toString() : '';
        if (id === 'min_experience' || id === 'max_experience') {
          error.experience = ''
        } else {
          error[id] = '';
        }
        this.setState({ contest, error });
      }
    } else {
      if (id === 'min_ctc' || id === 'max_ctc') {
        error.ctc = ''
      } else {
        if (error[id]) error[id] = '';
      }
      contest[id] = value;
      this.setState({ contest, error });
    }
  }

  editorInputChange = (id, value) => {
    const contest = this.state.contest;
    const error = this.state.error;

    contest[id] = value;
    if (error[id]) error[id] = '';
    this.setState({ contest, error });
  }

  dropdownChange = (id, name) => {
    const contest = this.state.contest;
    const error = this.state.error;

    if (typeof id !== 'undefined' && id !== null && id !== '') {
      contest[name] = id;
      if (name === 'min_experience' || name === 'max_experience') {
        error.experience = '';
      } else if (name === 'min_ctc' || name === 'max_ctc') {
        error.ctc = '';
      } else {
        error[name] = '';
      }
    }

    if (name === 'company_id') {
      this.props.testRequest(id);
    }

    this.setState({ contest, error });
  }

  autoCompleteChange = (name, value) => {
    // const contest = this.state.contest;
    // const error = this.state.error;

    if (name === 'job_location_list') {
      this.props.locationRequest(value);
    } else if (name === 'skills_list') {
      this.props.skillRequest(value);
    }
  }

  autoCompleteSelect = (name, value) => {
    const contest = this.state.contest;
    if (value && contest && contest[name] && !contest[name].includes(value)) {
      contest[name].push(value);
      const error = this.state.error;
      error[name] = '';
      this.setState({ contest, error });
      if (name === 'job_location_list') {
        this.props.locationClear();
      } else if (name === 'skills_list') {
        this.props.skillClear();
      }
    }
  }

  autoCompleteRemove = (name, index) => {
    if (name && typeof index !== 'undefined') {
      const contest = this.state.contest;
      contest[name].splice(index, 1);
      this.setState({ contest });
    }
  }

  saveContest = (isActive) => {
    let {
      company_id,
      job_title,
      job_location_type,
      job_location_list,
      min_experience,
      max_experience,
      min_ctc,
      max_ctc,
      // ctc_currency,
      openings,
      job_start_date,
      skills_list,
      job_type,
      job_description,
      contest_start_date,
      contest_end_date,
      test_id,
    } = this.state.contest;
    const error = this.state.error;

    let isValid = true;

    function isInvalid(key, value) {
      error[key] = value;
      isValid = false;
    }
  
    if (job_title.trim() === '') isInvalid('job_title', 'Please enter job title');
    if (job_description.trim() === '') isInvalid('job_description', 'Please enter job description');

    if (company_id === '') isInvalid('company_id', 'Please select company');
    if (job_location_type === '') isInvalid('job_location_type', 'Please select job location type');
    
    if (min_experience === '' || max_experience === '') {
      isInvalid('experience', 'Please select experience');
    } else if (parseInt(min_experience) > parseInt(max_experience)) {
      isInvalid('experience', 'Please select valid experience');
    }

    if (min_ctc === '' || max_ctc === '') {
      isInvalid('ctc', 'Please enter ctc');
    }/*  else if (parseInt(min_ctc) > parseInt(max_ctc)) {
      isInvalid('ctc', 'Please select valid ctc');
    } */
    
    if (openings === '') isInvalid('openings', 'Please enter job openings');
    if (test_id === '') isInvalid("test_id", "Please select owner's test");
    if (job_type === '') isInvalid('job_type', 'Please select job type');

    if (job_start_date === '') {
      isInvalid('job_start_date', 'Please select job start date');
    }

    if (contest_start_date === '') {
      isInvalid('contest_start_date', 'Please select contest start date');
    } else if (contest_end_date === '') {
      isInvalid('contest_end_date', 'Please select contest end date');
    } else if (contest_start_date > contest_end_date) {
      isInvalid('contest_end_date', 'Please select end date after start date');
    }
    
    if (job_location_list && job_location_list.length < 1) {
      isInvalid('job_location_list', 'Please select job location');
    }
    if (skills_list && skills_list.length < 1) {
      isInvalid('skills_list', 'Please select skills');
    } 

    if (isValid === true) {
      const data = {
        "company_id": company_id,
        "job_title": job_title,
        "job_location_type": job_location_type,
        "job_location_list": `{${job_location_list.join().toUpperCase()}}`,
        "min_experience": min_experience,
        "max_experience": max_experience,
        "ctc_currency": "INR",
        "min_ctc": min_ctc,
        "max_ctc": max_ctc,
        "openings": openings,
        "job_start_date": job_start_date,
        "skills_list": `{${skills_list.join().toUpperCase()}}`,
        "job_type": job_type,
        "job_description": job_description,
        "contest_start_date": moment(contest_start_date).format('YYYY-MM-DD HH:mm:0.000 Z'),
        "contest_end_date": moment(contest_end_date).format('YYYY-MM-DD HH:mm:0.000 Z'),
        "test_id": test_id,
        "is_active": isActive
      };
      if (this.state.pageMode === 'edit') {
        data.contest_id = this.state.contest.contest_id;
      }
      this.props.addRequest(data, this.state.pageMode);
    } else {
      this.setState({ error });
    }
  }

  radioChange = (index, listName, valueName) => {
    const list = this.state[listName];
    const contest = this.state.contest;
    const error = this.state.error;

    list.map((x) => (x.selected = false));
    list[index].selected = true;
    contest[valueName] = list[index].title.toUpperCase();
    error[valueName] = '';
    this.setState({ [listName]: list, contest, error });
  }

  render () {
    const { locationTypeList, currencyList, jobTypeList, error, pageMode, contest } = this.state;
    const { ownerLoading, testLoading, addContestLoading, getContestLoading, owners, tests, locations, skills } = this.props.addContest;

    let heading = 'Contest';
    if (pageMode !== '') {
      heading = pageMode === 'edit' ? 'Edit Contest' : 'New Contest';
    }

    const today = new Date().toISOString().split('.')[0];
    const dateWithoutSec = today.substring(0, today.lastIndexOf(":"));

    return (
      <Styled.MainDiv>
        <Loader show={ownerLoading || testLoading || addContestLoading || getContestLoading} heading={pageMode === 'edit' ? 'Updating Contest' : 'Adding Contest'} />
        <Sidemenu />
        <Styled.ColumnDiv>
          <Header />

          <Styled.ContentWrapDiv>

            <Styled.ContentDiv>
              <Styled.HeaderWrapDiv>
                <div>{heading}</div>
              </Styled.HeaderWrapDiv>

              { typeof owners !== 'undefined' ?
                <Styled.CardDiv style={{ paddingTop: '30px' }}>
                  <Styled.InputWrap style={{ marginTop: '20px' }}>
                    <Styled.InputTitleDiv>Select Account Name</Styled.InputTitleDiv>
                    <Dropdown title="Select Company" list={owners || []} value="id" name="company_id" selected={this.dropdownChange} width="600px" height="48px" option="title" active={contest} error={error.company_id !== ''} />
                    <Styled.InputErrorDiv>{error.company_id}</Styled.InputErrorDiv>
                  </Styled.InputWrap>

                  <Styled.InputWrap error={error.job_title !== ''}>
                    <Styled.InputTitleDiv>Enter Job Title</Styled.InputTitleDiv>
                    <input type="text" id="job_title" placeholder="e.g Java Developer" value={contest.job_title} onChange={(e) => this.inputChange(e)} />
                    <Styled.InputErrorDiv>{error.job_title}</Styled.InputErrorDiv>
                  </Styled.InputWrap>

                  <Styled.InputWrap>
                    <Styled.InputTitleDiv>Select Job Location Type</Styled.InputTitleDiv>
                    <RadioButton list={locationTypeList} value="id" name="title" selected={this.radioChange} width="600px" rowItemCount={4} listName="locationTypeList" radioName="job_location_type" />
                    <Styled.InputErrorDiv>{error.job_location_type}</Styled.InputErrorDiv>
                  </Styled.InputWrap>

                  <Styled.InputWrap>
                    <Styled.InputTitleDiv>Select Job Location</Styled.InputTitleDiv>
                    <InputSuggestion placeholder="e.g Delhi NCR, Chennai etc" list={(locations && locations.locationsList) || []} value="id" name="job_location_list" selected={this.autoCompleteSelect} change={this.autoCompleteChange} remove={this.autoCompleteRemove} width="600px" height="48px" option="city_name" active={contest.job_location_list} error={error.job_location_list !== ''} info="You can choose multiple locations" />
                    <Styled.InputErrorDiv>{error.job_location_list}</Styled.InputErrorDiv>
                  </Styled.InputWrap>

                  <Styled.InputWrap error={error.experience !== ''}>
                    <Styled.InputTitleDiv>Select Experience Range</Styled.InputTitleDiv>
                    <div style={{ width: '600px', display: 'flex', justifyContent: 'space-between' }}>
                      <input type="text" id="min_experience" placeholder="From" value={contest.min_experience} onChange={(e) => this.inputChange(e)} style={{ width: '292px' }} />
                      <input type="text" id="max_experience" placeholder="To" value={contest.max_experience} onChange={(e) => this.inputChange(e)} style={{ width: '292px' }} />
                    </div>
                    <Styled.InputErrorDiv>{error.experience}</Styled.InputErrorDiv>
                  </Styled.InputWrap>

                  <Styled.InputWrap error={error.ctc !== ''}>
                    <Styled.InputTitleDiv>Select CTC Range (in lakhs)</Styled.InputTitleDiv>
                    <div style={{ width: '600px', display: 'flex', justifyContent: 'space-between' }}>
                      <Dropdown title="Currency" list={currencyList} value="id" name="ctc_currency" selected={this.dropdownChange} width="115px" height="48px" option="title" active={contest} />
                      <input type="text" id="min_ctc" placeholder="Minimum" value={contest.min_ctc} onChange={(e) => this.inputChange(e)} style={{ width: '226px' }} />
                      <input type="text" id="max_ctc" placeholder="Maximum" value={contest.max_ctc} onChange={(e) => this.inputChange(e)} style={{ width: '226px' }} />
                    </div>
                    <Styled.InputErrorDiv>{error.experience}</Styled.InputErrorDiv>
                  </Styled.InputWrap>

                  <Styled.InputWrap error={error.openings !== ''}>
                    <Styled.InputTitleDiv>No. of Openings</Styled.InputTitleDiv>
                    <input type="text" id="openings" placeholder="e.g 1,2 etc" value={contest.openings} onChange={(e) => this.inputChange(e)} />
                    <Styled.InputErrorDiv>{error.openings}</Styled.InputErrorDiv>
                  </Styled.InputWrap>

                  <Styled.InputWrap error={error.job_start_date !== ''}>
                    <Styled.InputTitleDiv>Job Start Date</Styled.InputTitleDiv>
                    <input type="date" id="job_start_date" min={new Date().toISOString().split('T')[0]} placeholder="Choose Date" value={contest.job_start_date} onChange={(e) => this.inputChange(e)} />
                    <Styled.InputErrorDiv>{error.job_start_date}</Styled.InputErrorDiv>
                  </Styled.InputWrap>

                  <Styled.InputWrap>
                    <Styled.InputTitleDiv>Add Skills Required</Styled.InputTitleDiv>
                    <InputSuggestion placeholder="e.g Java, PHP, React etc" list={(skills && skills.skillsList) || []} value="id" name="skills_list" selected={this.autoCompleteSelect} change={this.autoCompleteChange} remove={this.autoCompleteRemove} width="600px" height="48px" option="name" active={contest.skills_list} error={error.skills_list !== ''} info="You can choose multiple skills" />
                    <Styled.InputErrorDiv>{error.skills_list}</Styled.InputErrorDiv>
                  </Styled.InputWrap>

                  <Styled.InputWrap>
                    <Styled.InputTitleDiv>Select Job Type</Styled.InputTitleDiv>
                    <RadioButton list={jobTypeList} value="id" name="title" selected={this.radioChange} width="500px" rowItemCount={3} listName="jobTypeList" radioName="job_type" />
                    <Styled.InputErrorDiv>{error.job_type}</Styled.InputErrorDiv>
                  </Styled.InputWrap>

                  <Styled.InputWrap>
                    <Styled.InputTitleDiv>Job Description</Styled.InputTitleDiv>
                    <Editor height="200px" width="600px" id="job_description" placeholder="Tell us about your company" value={contest.job_description} change={this.editorInputChange} />
                    <Styled.InputErrorDiv>{error.job_description}</Styled.InputErrorDiv>
                  </Styled.InputWrap>

                  <Styled.InputWrap>
                    <Styled.InputTitleDiv>Select Test</Styled.InputTitleDiv>
                    <Dropdown title="Select test" list={tests && tests.test_list ? tests.test_list : []} value="id" name="test_id" selected={this.dropdownChange} width="600px" height="48px" option="test_title" active={contest} error={error.test_id !== ''} />
                    <Styled.InputErrorDiv>{error.test_id}</Styled.InputErrorDiv>
                  </Styled.InputWrap>

                  <Styled.InputTitleDiv style={{ margin: '10px 0px 0px 30px', fontWeight: 'bold' }}>Publish Details</Styled.InputTitleDiv>

                  <Styled.InputWrap>
                    <div style={{ width: '600px', display: 'flex', justifyContent: 'space-between' }}>
                      <Styled.InputWrap error={error.contest_start_date !== ''} style={{ padding: '0px' }}>
                        <Styled.InputTitleDiv>Job Start Date</Styled.InputTitleDiv>
                        <input type="datetime-local" id="contest_start_date" min={dateWithoutSec} placeholder="Choose Date" value={contest.contest_start_date} onChange={(e) => this.inputChange(e)} style={{ width: '292px' }} />
                        <Styled.InputErrorDiv>{error.contest_start_date}</Styled.InputErrorDiv>
                      </Styled.InputWrap>

                      <Styled.InputWrap error={error.contest_end_date !== ''} style={{ padding: '0px' }}>
                        <Styled.InputTitleDiv>Job End Date</Styled.InputTitleDiv>
                        <input type="datetime-local" id="contest_end_date" min={contest.contest_start_date} placeholder="Choose Date" value={contest.contest_end_date} onChange={(e) => this.inputChange(e)} style={{ width: '292px' }} />
                        <Styled.InputErrorDiv>{error.contest_end_date}</Styled.InputErrorDiv>
                      </Styled.InputWrap>
                    </div>
                  </Styled.InputWrap>

                  <Styled.SaveWrapDiv style={{ marginTop: '24px' }}>
                    <Styled.SaveButton onClick={() => this.saveContest(true)}>Save &amp; Publish</Styled.SaveButton>
                    <Styled.DraftButton onClick={() => this.saveContest(false)}>Save Draft</Styled.DraftButton>
                  </Styled.SaveWrapDiv>

                </Styled.CardDiv>
              : ''
              }
            </Styled.ContentDiv>

            <Footer />
          </Styled.ContentWrapDiv>

        </Styled.ColumnDiv>
      </Styled.MainDiv>
    )
  }
}

const mapStateToProps = state => ({
  addContest: state.addContest,
})

const mapDispatchToProps = {
  getRequest,
  addRequest,
  addClear,
  ownerRequest,
  testRequest,
  locationRequest,
  skillRequest,
  locationClear,
  skillClear,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddContest)
